export enum AccountingCloseType {
  Monthly = "MONTHLY",
  Yearly = "YEARLY",
  SetupNewYear = "SETUP_NEW_YEAR"
}
